if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
      const dateVariant = document.querySelector('.date-variant');
      if (dateVariant) {
       const activeLinks = document.querySelectorAll('.date-variant a.active');
       const checkCounts = activeLinks.length;
        if(checkCounts === 0){
          const firstBulletSlider = document.querySelector('.slider_main_iamges .swiper-pagination .swiper-pagination-bullet');
            if (firstBulletSlider) {
            firstBulletSlider.click();
          }
          const fold_product_detail = document.querySelector('.fold_product_detail');
          if(fold_product_detail){
            fold_product_detail.classList.add('fold_product_option_active');
            document.querySelector('body').classList.add('fold_option_active');
            const productsInfo = document.querySelector('.product__info-wrapper');
            if (productsInfo) {
              productsInfo.scrollIntoView({ behavior: 'smooth', top: 0 });
            }
          }
          return false;
        }
      }

    const cartPopupOpen = document.querySelector('.hide_option_select');
    if (cartPopupOpen && cartPopupOpen.classList.contains('cart-popup-open-btn')) {
    const productDetails_checkClass = document.getElementById('productDetails');
    let checkPopupCount = 0;
    if (productDetails_checkClass && productDetails_checkClass.classList.contains('add_to_cart_yes')) {
      productDetails_checkClass.classList.remove('add_to_cart_yes');
    } else {
      const productPopups = document.querySelectorAll('.product-popup');
      if (productPopups.length > 0) {
        const selectedValue = document.getElementById('productSelect').value;
        const productDetails = document.getElementById('productDetails');
        productPopups.forEach(popup => {
          const variantsBox = popup.getAttribute('data-variants');
          popup.classList.toggle('active', variantsBox === selectedValue);
          if(variantsBox === selectedValue){
            productDetails.classList.add('popup_active_product_main');
            checkPopupCount = 1;
            if (window.innerWidth >= 1024) {
            if (productDetails) {
                    window.scrollTo({
                        top: productDetails.offsetTop + 200,
                        behavior: 'smooth'
                    });
            }
            } else {
                const productVariants = document.querySelector('.product-variants');
                if (productVariants) {
                    // Scroll to the top of the productVariants div + 50px offset
                    const topPosition = productVariants.getBoundingClientRect().top + window.scrollY + 50;
                    window.scrollTo({
                        top: topPosition,
                        behavior: 'smooth'
                    });
                }
            }

          }
        });
      }
    }
    if(checkPopupCount == 1){
      return false;
    }
  }


        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const addons = localStorage.getItem('addons');
        if (addons === 'true') {
          const mainId = formData.get('id');
          const itemId = formData.get('items[0][id]');
          if (mainId && itemId) {
            formData.set('id', itemId);
            formData.set('items[0][id]', mainId);
          }
          localStorage.removeItem('addons');
        }
 
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              const cartWrapper = document.querySelector('.cart-drawer, .cart__items, body'); // adjust selector to where upsells are injected
              if (cartWrapper) {
              const observer = new MutationObserver(() => {
              const upsellContents = document.querySelectorAll('.drawer__cart-items-wrapper .button__upsell + *');
              upsellContents.forEach((content) => {
              if (!content.dataset.swiperInit && content.querySelector('.mySwiperSlider')) {
              initializeSwiper(content);
              content.dataset.swiperInit = 'true';
              }
              });
              });
              observer.observe(cartWrapper, { childList: true, subtree: true });
              setTimeout(() => observer.disconnect(), 3000);
              }

              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

